import { Injectable } from '@angular/core';
import {
  IProductPagination,
  IProduct,
  IProductState,
} from '../models/product.model';
import { IBaseTableResult } from '../models/table.model';
import { Observable, forkJoin, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  getProducts(pagination: IProductPagination): Observable<{
    products: IProduct[];
    pagination: IProductPagination;
  }> {
    return forkJoin(this.getProductsList(pagination)).pipe(
      map(res => {
        return {
          products: res[0].items,
          pagination: {
            current_page: res[0].current_page,
            has_more_data: res[0].has_more_data,
            page_size: res[0].current_page_size,
            total_pages_count: res[0].total_page_count,
          },
        };
      })
    );
  }

  getProductsList(pagination: IProductPagination): Observable<any> {
    return this.http.get<IBaseTableResult<IProduct>>(
      environment.apiUrl + '/v1/products',
      {
        params: {
          only_enabled: 'false',
          page_size: pagination.page_size.toString(),
          page: pagination.current_page.toString(),
        },
      }
    );
  }

  createProduct(product) {
    return this.http.post(environment.apiUrl + '/v1/products', product);
  }

  updateProduct(product) {
    return this.http.put(
      environment.apiUrl + '/v1/products/' + product.id,
      product
    );
  }

  deleteProduct(product) {
    return this.http.delete(environment.apiUrl + '/v1/products/' + product.id);
  }

  constructor(private http: HttpClient) {}
}
